const isEmptyElement = require('./isEmptyElement');

const hasContent = ({ value }) => value.some((node) => !isEmptyElement(node));

module.exports = hasContent;
